// extracted by mini-css-extract-plugin
module.exports = {"waterfall":"_5948","noCompleteTips":"_13603"};